import { createSelector } from 'reselect';

import {
  getCanManageTier,
  getCurrentUserIsManagerial,
} from 'selectors/session';

import {
  selectCurrentLocationTier,
  selectIsPastDueAfterDeadline,
  selectPreSetPastDueDialogInitialViewKey,
} from 'features/biller/selectors';
import { selectShouldShowEnforcementDialogOnNavigation } from 'features/enforcement/EnforcementBanner/selectors';
import { selectDisplayDialog } from 'features/enforcement/selectors';

import { getInitialViewKey } from './getInitialViewKey';

// ACL between selectors composition and getInitialViewKey
// Those arguments from createSelector are positional, touch with care
export const selectInitialPastDueDialogViewKey = createSelector(
  selectShouldShowEnforcementDialogOnNavigation,
  getCanManageTier,
  selectPreSetPastDueDialogInitialViewKey,
  selectCurrentLocationTier,
  selectIsPastDueAfterDeadline,
  selectDisplayDialog,
  getCurrentUserIsManagerial,
  (
    shouldShowEnforcementDialogOnNavigation,
    canManageTier,
    preSetInitialViewKey,
    currentLocationTier,
    isPastDueAfterDeadline,
    displayDialog,
    isCurrentUserManagerial
  ) =>
    getInitialViewKey({
      displayDialog,
      canManageTier,
      currentLocationTier,
      preSetInitialViewKey,
      isPastDueAfterDeadline,
      isCurrentUserManagerial,
      shouldShowEnforcementDialogOnNavigation,
    })
);
